
export type CancelAdminAccountSubscriptionBody = {
  /** @nullable */
  reason?: string | null;
  subscriptionId: number;
  userId: string;
};
